export default __webpack_public_path__ + "static/media/Course-Icons8.b84e2a83.svg";